import React from "react";
import ProductTable from "./ProductTable";

const Products = () => {
    return (
        <div>
            <h1 className='font-bold mb-5 text-xl'>All Products</h1>
            <ProductTable/>
        </div>
    )
}

export default Products